












import Vue from "vue";
import { mapActions } from "vuex";
import config from "@/configs";

export default Vue.extend({
  name: "SignWithEmailLinkLandingCard",

  async created(): Promise<void> {
    if (config?.settings.signInEmailLink) {
      await this.loginInWithEmailLink().then((result: boolean) => {
        if (!result) this.$emit("signInFailed");
      });
    }
  },
  methods: {
    ...mapActions("auth", ["loginInWithEmailLink"]),
  },
});
